export const updateStateReducer = (state, action)=>{
        return { ...state, [action.type]: action.payload };
}
 